import {createSlice, PayloadAction} from '@reduxjs/toolkit'
import {
  DashboardStatistics,
  BookingStatistics,
  RevenueStatistics,
  ServiceStatistics,
  AgentStatistics,
} from '../../../app/modules/statistics/models/StatisticsModels'

interface StatisticsState {
  dashboard: DashboardStatistics | null
  bookings: BookingStatistics | null
  revenue: RevenueStatistics | null
  services: ServiceStatistics | null
  agents: AgentStatistics | null
  loading: boolean
  error: string | null
}

const initialState: StatisticsState = {
  dashboard: null,
  bookings: null,
  revenue: null,
  services: null,
  agents: null,
  loading: false,
  error: null,
}

export const StatisticsSlices = createSlice({
  name: 'statistics',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload
      state.loading = false
    },
    setDashboard: (state, action: PayloadAction<DashboardStatistics>) => {
      state.dashboard = action.payload
      state.loading = false
      state.error = null
    },
    setBookings: (state, action: PayloadAction<BookingStatistics>) => {
      state.bookings = action.payload
      state.loading = false
      state.error = null
    },
    setRevenue: (state, action: PayloadAction<RevenueStatistics>) => {
      state.revenue = action.payload
      state.loading = false
      state.error = null
    },
    setServices: (state, action: PayloadAction<ServiceStatistics>) => {
      state.services = action.payload
      state.loading = false
      state.error = null
    },
    setAgents: (state, action: PayloadAction<AgentStatistics>) => {
      state.agents = action.payload
      state.loading = false
      state.error = null
    },
    clearError: (state) => {
      state.error = null
    },
  },
})

export const {
  setLoading,
  setError,
  setDashboard,
  setBookings,
  setRevenue,
  setServices,
  setAgents,
  clearError,
} = StatisticsSlices.actions

export default StatisticsSlices.reducer
